import React from "react";
import { CartViewButtonProps } from "./CartViewButton.types";
import { ProductImage } from "./CartViewButton.styles";
import {
  Body5MediumTypography,
  Body6RegularTypography,
} from "../../primitives/Typography/typographyVariants";
import { colorPalette } from "../../theme/colors";
import { Icon } from "../Icon/Icon";
import FlexRow from "../Layout/FlexRow/FlexRow";
import Box from "../../primitives/Box/Box";
import FlexColumn from "../Layout/FlexColumn/FlexColumn";

export const CartViewButton: React.FC<CartViewButtonProps> = ({
  cartItems,
  itemCount,
  onClick,
  disabled,
  dataCy,
}) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <FlexRow zIndex={1000} height={52} width="unset">
      <Box
        display="inline-flex"
        p="small"
        gap="small"
        borderRadius={26}
        backgroundColor={colorPalette.popOrange[300]}
        opacity={disabled ? 0.6 : 1}
        transition="opacity 0.2s ease"
        alignItems="center"
      >
        <Box display="flex" flex="0 1 auto" width="fit-content">
          {cartItems?.slice(0, 3).map((item, index) => (
            <ProductImage
              key={index}
              src={item?.thumbnail_url}
              alt={`cart-item-${index}`}
              index={index}
              isSingle={cartItems.length === 1}
            />
          ))}
        </Box>
        <FlexColumn alignItems="flex-start" width="unset">
          <Body5MediumTypography color={colorPalette.popWhite[500]}>
            View cart
          </Body5MediumTypography>
          <Body6RegularTypography
            color={colorPalette.popWhite[300]}
            data-cy={`${dataCy}-item-count`}
          >
            {itemCount} {itemCount === 1 ? "item" : "items"}
          </Body6RegularTypography>
        </FlexColumn>
        <FlexColumn
          height="36px"
          width="36px"
          py="12px"
          alignItems="center"
          justifyContent="center"
          onClick={handleClick}
          data-cy={dataCy}
          backgroundColor={colorPalette.popOrange[500]}
          borderRadius="50%"
          cursor={disabled ? "default" : "pointer"}
        >
          <Icon
            name="fa-sharp fa-solid fa-chevron-right"
            color={colorPalette.popWhite[500]}
            size="12"
            cursor="pointer"
            dataCy={`${dataCy}-chevron-right`}
          />
        </FlexColumn>
      </Box>
    </FlexRow>
  );
};
